import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export { formatDate, formatRelativeTime } from './formatDate';
export { extractJiraIssue, splitImageTag, getJiraIssueUrl } from './jira';
